import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SITE } from "../config";

const loadAnalytics = () => {
  if (SITE.ga4Id) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${SITE.ga4Id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", SITE.ga4Id);
  }
  if (SITE.metaPixelId) {
    const s = document.createElement("script");
    s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${SITE.metaPixelId}');fbq('track','PageView');`;
    document.head.appendChild(s);
  }
};

export const CookieBanner = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem("lc-consent"));

  useEffect(() => {
    if (choice === "accepted") loadAnalytics();
  }, [choice]);

  const decide = (value) => {
    localStorage.setItem("lc-consent", value);
    setChoice(value);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: 1.2 }}
          className="fixed bottom-20 left-4 right-4 z-[60] mx-auto max-w-lg rounded-2xl border border-white/10 bg-card/95 p-5 shadow-2xl backdrop-blur-xl sm:left-6 sm:right-auto lg:bottom-4"
          role="dialog"
          aria-label="Cookie consent"
        >
          <p className="text-sm font-semibold text-white">A quick note on cookies</p>
          <p className="mt-1.5 text-xs leading-relaxed text-mist">
            We use analytics cookies only if you say yes, to understand which pages help visitors.
            No ads, no selling data, ever.
          </p>
          <div className="mt-4 flex gap-3">
            <button
              type="button"
              data-testid="cookie-consent-accept-button"
              onClick={() => decide("accepted")}
              className="rounded-full bg-volt px-5 py-2 text-xs font-bold text-ink transition-transform duration-300 hover:-translate-y-0.5"
            >
              Accept
            </button>
            <button
              type="button"
              data-testid="cookie-consent-decline-button"
              onClick={() => decide("declined")}
              className="rounded-full border border-white/15 px-5 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-volt/50 hover:text-volt"
            >
              Decline
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
